import React from 'react';

import type { AudioNode } from './../../ricos-schema/next-schema';

import { getAudioSrc } from '../consts';
import { ROOT } from '../data-hooks';
import styles from '../statics/styles/audio.rtlignore-scss';
import type { AudioPluginViewerConfig } from '../types';
import AudioEmbedViewer from './audio-embed-viewer';
import { ReactPlayerWrapper } from './react-player-wrapper';

interface Props {
  node: AudioNode;
  settings: AudioPluginViewerConfig;
  disabled?: boolean;
  isLoading?: boolean;
  updateAttributes?: (args: $TSFixMe) => void;
}

const AudioViewer: React.FC<Props> = ({
  node,
  settings,
  disabled,
  isLoading,
  updateAttributes,
}) => {
  const { audio, authorName, name, coverImage, disableDownload, html } = node.audioData || {};
  const url = getAudioSrc(audio?.src, settings);
  const shouldEmbed = !!html;
  const saveDurationToData = (duration: $TSFixMe) =>
    updateAttributes?.({ audio: { ...audio, duration } });

  return (
    <div className={styles.container} data-hook={ROOT}>
      {!shouldEmbed ? (
        <ReactPlayerWrapper
          url={url}
          name={name}
          authorName={authorName}
          coverImage={{ src: coverImage?.src.id }}
          disableDownload={disableDownload}
          helpers={{}}
          disabled={disabled}
          isLoading={isLoading}
          saveDurationToData={saveDurationToData}
        />
      ) : (
        <AudioEmbedViewer node={node} settings={settings} />
      )}
    </div>
  );
};

export default AudioViewer;
